import { Box, Button, Stack, Tab, Tabs, Typography } from '@mui/material';
import { CustomTabPanel, a11yProps } from '../../../components/Atoms/CustomTabPanel';
import React from 'react';
import { useTranslation } from 'react-i18next';
import TimeSelectSlider from '../components/TimeSelectSlider';
import { useIsMobile } from '../../../hooks/useIsMobile';

type argType = {
  isImageIdChecking: boolean;
  isTileURLLoading: boolean;
  increment: number;
  setIncrement: React.Dispatch<React.SetStateAction<number>>;
};

export const useTileSelector = ({
  isImageIdChecking,
  isTileURLLoading,
  increment,
  setIncrement,
}: argType) => {
  // 起算時刻からのズレをtimeIdxとして保存

  return {
    TileSelector: (
      <TileSelectorComponent
        increment={increment}
        setIncrement={setIncrement}
        isUrlLoading={isTileURLLoading}
        isImageIdChecking={isImageIdChecking}
      />
    ),
    increment,
  };
};

type Props = {
  increment: number;
  setIncrement: React.Dispatch<React.SetStateAction<number>>;
  isUrlLoading: boolean;
  isImageIdChecking: boolean;
};

const TileSelectorComponent: React.FC<Props> = ({
  increment,
  setIncrement,
  isUrlLoading,
  isImageIdChecking,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const [tabValue, setTabValue] = React.useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <>
      <Stack direction="row" spacing={3}>
        <Button onClick={(e) => handleTabChange(e, 0)} variant="contained" color="success">{t('pages.predictionMap.fld_prediction')}</Button>
        <Button onClick={(e) => handleTabChange(e, 1)} variant="contained" color="success">{t('pages.predictionMap.precipitation_pred')}</Button>
        <Button onClick={(e) => handleTabChange(e, 2)} variant="contained" color="success">{t('pages.jmaAlerts.title')}</Button>
      </Stack>

      <CustomTabPanel value={tabValue} index={0}>
        <TimeSelectSlider
          setIncrement={setIncrement}
          increment={increment}
          isUrlLoading={isUrlLoading}
          isImageIdChecking={isImageIdChecking}
        />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={1}>
        <Typography sx={{ fontSize: '10pt' }}>
          {t('pages.predictionMap.tbd')}
        </Typography>
      </CustomTabPanel>
    </>
  )

  return (
    <Box sx={{ width: '100%', backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: '4px' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
          <Tab label={t('pages.predictionMap.fld_prediction')} {...a11yProps(0)} />
          <Tab label={t('pages.predictionMap.precipitation_pred')} {...a11yProps(1)} />
        </Tabs>
      </Box>
      <CustomTabPanel value={tabValue} index={0}>
        <TimeSelectSlider
          setIncrement={setIncrement}
          increment={increment}
          isUrlLoading={isUrlLoading}
          isImageIdChecking={isImageIdChecking}
        />
      </CustomTabPanel>
      <CustomTabPanel value={tabValue} index={1}>
        <Typography sx={{ fontSize: '10pt' }}>
          {t('pages.predictionMap.tbd')}
        </Typography>
      </CustomTabPanel>
    </Box>
  );
};

export default useTileSelector;
